import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
// routing
import Routes from 'routes';
import { CookiesProvider } from 'react-cookie';
// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    const theme = themes(customization);
    return (
    <StyledEngineProvider injectFirst>
      <CookiesProvider>
        <MuiThemeProvider theme={theme}>
          <StylesThemeProvider theme={theme}>
            <CssBaseline />
            <NavigationScroll>
              <Routes />
            </NavigationScroll>
          </StylesThemeProvider>
        </MuiThemeProvider>
      </CookiesProvider>
    </StyledEngineProvider>
  );
};

export default App;
